import Vue from 'vue';
import App from './App.vue';
import KaerComponent from '@kaer/kaer-component';
import init from './init';
import '@/styles/main.scss';
import '@/utils/flexable';
import { initAdapter, getAdapter, env, ZYToast } from '@zyf2e/adapt';
import '@zyf2e/capui-mobile/lib/index.css';
import { Sticky, Popup, Toast, Dialog } from '@zyf2e/capui-mobile';
import { apiUrl } from '@/config';
import Components from './components';
import { px2rem, getUrlParam } from './utils/utils';
import { uploadData } from '@/utils/uploadData';

Vue.config.productionTip = false;

Vue.directive('track-event', Telescope.vTrackEvent);
Vue.directive('track-view', Telescope.vTrackView);
Vue.directive('track-page', Telescope.vTrackPage);
Vue.use(KaerComponent, init(Vue));
Vue.use(Components);
Vue.use(Sticky)
  .use(Popup)
  .use(Dialog)
  .use(Toast);

async function main() {
  const activityId = window.__kaer_config__?.page?.props?.activityId;
  await initAdapter({
    baseURL: apiUrl,
    jumpWechatMPLogin: true,
    loginTelescopeParams: {
      activityId: activityId || undefined,
      channel: getUrlParam('channel') || undefined
    }
  });
  const adapt = getAdapter();
  Vue.prototype.adapt = adapt;
  Vue.prototype.env = env;
  Vue.prototype.ZYToast = ZYToast;
  Vue.prototype.px2rem = px2rem;
  Vue.prototype.uploadData = uploadData;
  Vue.prototype.$goBack = () => {
    if (env.inWechatMiniProgram) {
      wx.miniProgram.navigateBack();
    } else {
      adapt.goBack();
    }
  }

  window.__kaer_adapt__ = adapt;
  window.__kaer_uploadData__ = uploadData;

  new Vue({
    render: h => h(App)
  }).$mount('#app');
}

main();
